import { ApplicantsView } from "../Views/ApplicantsView";

export const ApplicantsPage = (props: { location: any }) => {
	const initialInternshipName = props.location.state?.internshipName;

	return <ApplicantsView initialInternshipName={initialInternshipName} />;
};
